import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "slider-arrow-left",
  "use": "slider-arrow-left-usage",
  "viewBox": "0 0 40 41",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 41\" id=\"slider-arrow-left\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.82 20.876 28 10.696l-2.912-2.908L12 20.876l13.088 13.088L28 31.056l-10.18-10.18Z\" fill=\"#BB1F42\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol